module.exports = __webpack_public_path__ + "img/16.576dafe0.svg";